import { APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AngularFireModule } from '@angular/fire';
import { CargarScriptsService } from "./cargar-scripts.service";

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxSpinnerModule } from 'ngx-spinner';

import {
  PerfectScrollbarModule,
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface
} from 'ngx-perfect-scrollbar';

import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { AppComponent } from './app.component';
import { ContentLayoutComponent } from './layouts/content/content-layout.component';
import { FullLayoutComponent } from './layouts/full/full-layout.component';

import { AuthService } from './shared/auth/auth.service';
import { AuthGuard } from './shared/auth/auth-guard.service';
import { WINDOW_PROVIDERS } from './shared/services/window.service';
import { AppSettings } from './shared/helpers/app-settings';
import { LogService } from './shared/services/log.service';
import { AuthInterceptor } from './shared/api/interceptors/auth.interceptor';
import { ToastrModule } from 'ngx-toastr';
import * as Sentry from '@sentry/angular';
import { Router } from '@angular/router';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AuthPagesGuardService } from './shared/auth/auth-pages-guard.service';
import { environment } from '../environments/environment';
import { NgSelectModule } from '@ng-select/ng-select';
import { ErrorHandlerModule } from './core/errors/error-handler.module';
import { CoreModule } from './core/core.module';
import { HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEsExtra from '@angular/common/locales/extra/es';
import { NgxMaskModule } from 'ngx-mask';
import { ValidityTokenInterceptor } from './shared/api/interceptors/validity-token.interceptor';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { PaymentResultComponent } from './pages/payment-result/payment-result.component';
//import { PaymentPlansComponent } from './src/app/payment-plans/payment-plans/payment-plans.component';


const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelPropagation: false
};

export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

registerLocaleData(localeEs, 'es', localeEsExtra);

@NgModule({
  declarations: [AppComponent, FullLayoutComponent, ContentLayoutComponent, PaymentResultComponent,],
  imports: [
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    HttpClientModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebase),
    CoreModule,
    NgbModule,
    NgSelectModule,
    ToastrModule.forRoot(),
    NgxSpinnerModule,
    NgxDatatableModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    PerfectScrollbarModule,
    NgxMaskModule.forRoot(),
  ],
  providers: [
    CargarScriptsService,
    { provide: LOCALE_ID, useValue: 'es-PY' },

    // Sentry
    // {
    //   provide: ErrorHandler,
    //   useValue: Sentry.createErrorHandler({
    //     showDialog: true,
    //   }),
    // },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {
      },
      deps: [Sentry.TraceService],
      multi: true,
    },

    // Interceptor por Auth
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ValidityTokenInterceptor, multi: true },
    AuthService,
    AuthGuard,
    AuthPagesGuardService,
    AppSettings,
    LogService,
    { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
    WINDOW_PROVIDERS,

    // Highlight Code
    {
      provide: HIGHLIGHT_OPTIONS,
      useValue: {
        coreLibraryLoader: () => import('highlight.js/lib/core'),
        lineNumbersLoader: () => import('highlightjs-line-numbers.js'),
        languages: {
          json: () => import('highlight.js/lib/languages/json'),
        }
      }
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

  constructor(private log: LogService) {
    this.log.setLevel(environment.logLevel);
  }

}
